import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Users from "./scenes/Users";
import Createuser from "./scenes/Createuser";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Subscription from "./scenes/Subscription";
import Createsubscription from "./scenes/Createsubscription";
import Reports from "./scenes/Reports";
import Logout from "./scenes/Logout";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar isSidebar={isSidebar} />
          <main className="content">
            <Topbar setIsSidebar={setIsSidebar} />
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/user" element={<Users />} />
              <Route path="/createuser" element={<Createuser />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/createsubscription" element={<Createsubscription />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/logout" element={<Logout />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
